export interface Contact {
    id: number;
    firstname: string;
    lastname: string;
}

export interface Tasks {
    id: number;
    job_no: number;
    job: string;
    task_name: string;
    assign_contact: Contact[];
    priority: 'High' | 'Medium' | 'Low';
    status: 'Done' | 'In progress';
}

export const tasks: Tasks[] = [
    {
        id: 1,
        job_no: 750,
        job: 'Oak Avenue',
        task_name: "Create report for project",
        assign_contact: [
            { id: 1, firstname: "John", lastname: "Doe" },
            { id: 2, firstname: "Billie", lastname: "Eilish" },
            { id: 3, firstname: "Alice", lastname: "Johnson" },
            { id: 4, firstname: "Bob", lastname: "Brown" }
        ],
        priority: 'High',
        status: 'Done',
    },
    {
        id: 2,
        job_no: 751,
        job: 'Pine Street',
        task_name: "Site inspection",
        assign_contact: [
            { id: 5, firstname: "Charlie", lastname: "Davis" }
        ],
        priority: 'Medium',
        status: 'In progress',
    },
    {
        id: 3,
        job_no: 752,
        job: 'Maple Lane',
        task_name: "Client meeting",
        assign_contact: [
            { id: 6, firstname: "David", lastname: "Evans" },
            { id: 7, firstname: "Eva", lastname: "Green" }
        ],
        priority: 'Low',
        status: 'Done',
    },
    {
        id: 4,
        job_no: 753,
        job: 'Birch Boulevard',
        task_name: "Prepare contract documents",
        assign_contact: [
            { id: 8, firstname: "Fiona", lastname: "Harris" }
        ],
        priority: 'High',
        status: 'In progress',
    },
    {
        id: 5,
        job_no: 754,
        job: 'Elm Road',
        task_name: "Update project timeline",
        assign_contact: [
            { id: 9, firstname: "George", lastname: "Ivy" }
        ],
        priority: 'Medium',
        status: 'Done',
    },
    {
        id: 6,
        job_no: 755,
        job: 'Cedar Drive',
        task_name: "Coordinate with subcontractors",
        assign_contact: [
            { id: 10, firstname: "Hannah", lastname: "Jones" }
        ],
        priority: 'Low',
        status: 'In progress',
    },
    {
        id: 7,
        job_no: 756,
        job: 'Willow Way',
        task_name: "Budget review meeting",
        assign_contact: [
            { id: 11, firstname: "Ian", lastname: "King" }
        ],
        priority: 'High',
        status: 'Done',
    },
    {
        id: 8,
        job_no: 757,
        job: 'Ash Street',
        task_name: "Review design plans",
        assign_contact: [
            { id: 12, firstname: "Jack", lastname: "Lewis" }
        ],
        priority: 'Medium',
        status: 'In progress',
    },
    {
        id: 9,
        job_no: 758,
        job: 'Fir Avenue',
        task_name: "Quality assurance check",
        assign_contact: [
            { id: 13, firstname: "Karen", lastname: "Morris" }
        ],
        priority: 'Low',
        status: 'Done',
    },
    {
        id: 10,
        job_no: 759,
        job: 'Spruce Circle',
        task_name: "Submit final report",
        assign_contact: [
            { id: 14, firstname: "Liam", lastname: "Nelson" }
        ],
        priority: 'High',
        status: 'In progress',
    },
    {
        id: 11,
        job_no: 760,
        job: 'Palm Place',
        task_name: "Client follow-up",
        assign_contact: [
            { id: 15, firstname: "Mia", lastname: "Owens" }
        ],
        priority: 'Medium',
        status: 'Done',
    },
    {
        id: 12,
        job_no: 761,
        job: 'Redwood Road',
        task_name: "Finalize project scope",
        assign_contact: [
            { id: 16, firstname: "Noah", lastname: "Parker" }
        ],
        priority: 'Low',
        status: 'In progress',
    },
    {
        id: 13,
        job_no: 762,
        job: 'Hickory Lane',
        task_name: "Document review",
        assign_contact: [
            { id: 17, firstname: "Olivia", lastname: "Quinn" }
        ],
        priority: 'High',
        status: 'Done',
    },
    {
        id: 14,
        job_no: 763,
        job: 'Cherry Court',
        task_name: "Draft project proposal",
        assign_contact: [
            { id: 18, firstname: "Paul", lastname: "Reed" }
        ],
        priority: 'Medium',
        status: 'In progress',
    },
    {
        id: 15,
        job_no: 764,
        job: 'Poplar Grove',
        task_name: "Site visit",
        assign_contact: [
            { id: 19, firstname: "Quincy", lastname: "Smith" }
        ],
        priority: 'Low',
        status: 'Done',
    },
    {
        id: 16,
        job_no: 765,
        job: 'Beech Lane',
        task_name: "Prepare budget estimate",
        assign_contact: [
            { id: 20, firstname: "Rachel", lastname: "Taylor" }
        ],
        priority: 'High',
        status: 'In progress',
    },
    {
        id: 17,
        job_no: 766,
        job: 'Cypress Road',
        task_name: "Review subcontractor bids",
        assign_contact: [
            { id: 21, firstname: "Samuel", lastname: "Upton" }
        ],
        priority: 'Medium',
        status: 'Done',
    },
    {
        id: 18,
        job_no: 767,
        job: 'Magnolia Street',
        task_name: "Update project schedule",
        assign_contact: [
            { id: 22, firstname: "Tina", lastname: "Vance" }
        ],
        priority: 'Low',
        status: 'In progress',
    },
    {
        id: 19,
        job_no: 768,
        job: 'Dogwood Drive',
        task_name: "Finalize contract terms",
        assign_contact: [
            { id: 23, firstname: "Uma", lastname: "West" }
        ],
        priority: 'High',
        status: 'Done',
    },
    {
        id: 20,
        job_no: 769,
        job: 'Sycamore Court',
        task_name: "Client presentation",
        assign_contact: [
            { id: 24, firstname: "Victor", lastname: "Xander" }
        ],
        priority: 'Medium',
        status: 'In progress',
    }
];

export interface Projects {
    id: number;
    job_no: number;
    project_address: string;
    project_type: 'Commercial' | 'Domestic';
    status: 'Current' | 'Ongoing' | 'Completed';
}

export const projects: Projects[] = [
    {
        id: 1,
        job_no: 750,
        project_address: "72 Oak Avenue, Heston, TW3 9EB",
        project_type: "Commercial",
        status: "Current",
    },
    {
        id: 2,
        job_no: 751,
        project_address: "15 Pine Street, Manchester, M1 2HG",
        project_type: "Domestic",
        status: "Ongoing",
    },
    {
        id: 3,
        job_no: 752,
        project_address: "45 Maple Lane, Birmingham, B3 1AQ",
        project_type: "Commercial",
        status: "Completed",
    },
    {
        id: 4,
        job_no: 753,
        project_address: "88 Birch Boulevard, Bristol, BS8 2JD",
        project_type: "Domestic",
        status: "Current",
    },
    {
        id: 5,
        job_no: 754,
        project_address: "10 Elm Road, Leeds, LS1 3AA",
        project_type: "Commercial",
        status: "Ongoing",
    },
    {
        id: 6,
        job_no: 755,
        project_address: "22 Cedar Drive, Liverpool, L1 9JG",
        project_type: "Domestic",
        status: "Completed",
    },
    {
        id: 7,
        job_no: 756,
        project_address: "39 Willow Way, Sheffield, S1 4GH",
        project_type: "Commercial",
        status: "Current",
    },
    {
        id: 8,
        job_no: 757,
        project_address: "67 Ash Street, Newcastle, NE1 8LA",
        project_type: "Domestic",
        status: "Ongoing",
    },
    {
        id: 9,
        job_no: 758,
        project_address: "5 Fir Avenue, Glasgow, G1 5JB",
        project_type: "Commercial",
        status: "Completed",
    },
    {
        id: 10,
        job_no: 759,
        project_address: "74 Spruce Circle, Edinburgh, EH1 2JY",
        project_type: "Domestic",
        status: "Current",
    },
    {
        id: 11,
        job_no: 760,
        project_address: "33 Palm Place, Cardiff, CF10 1DD",
        project_type: "Commercial",
        status: "Ongoing",
    },
    {
        id: 12,
        job_no: 761,
        project_address: "99 Redwood Road, Belfast, BT1 2JL",
        project_type: "Domestic",
        status: "Completed",
    },
    {
        id: 13,
        job_no: 762,
        project_address: "47 Hickory Lane, Nottingham, NG1 4AB",
        project_type: "Commercial",
        status: "Current",
    },
    {
        id: 14,
        job_no: 763,
        project_address: "28 Cherry Court, Oxford, OX1 1AA",
        project_type: "Domestic",
        status: "Ongoing",
    },
    {
        id: 15,
        job_no: 764,
        project_address: "56 Poplar Grove, Cambridge, CB2 3AA",
        project_type: "Commercial",
        status: "Completed",
    },
    {
        id: 16,
        job_no: 765,
        project_address: "81 Beech Lane, Southampton, SO14 7DN",
        project_type: "Domestic",
        status: "Current",
    },
];


export interface Services {
    folder_id: number;
    project_id: number;
    folder: string;
    type: string;
    service_name: string;
    folder_type: string;
    feature_key_name: string;
}

export const services: Services[] = [
    {
        folder_id: 1,
        project_id: 1,
        folder: 'Pre Comencencemet',
        type: 'Custom',
        service_name: "Planning",
        folder_type: 'Drawing',
        feature_key_name: ''
    },
    {
        folder_id: 1,
        project_id: 1,
        folder: 'Pre Comencencemet',
        type: 'Custom',
        service_name: "Party wall",
        folder_type: 'Document',
        feature_key_name: ''
    },
    {
        folder_id: 1,
        project_id: 1,
        folder: 'Pre Comencencemet',
        type: 'Default',
        service_name: "Tender",
        folder_type: '',
        feature_key_name: 'tender'
    },
    {
        folder_id: 1,
        project_id: 1,
        folder: 'Pre Comencencemet',
        type: 'Default',
        service_name: "Discharge condition",
        folder_type: '',
        feature_key_name: 'discharge-condition'
    },
    {
        folder_id: 2,
        project_id: 1,
        folder: 'Onsite',
        type: 'Default',
        service_name: "Valuation",
        folder_type: '',
        feature_key_name: 'valuation'
    },
    {
        folder_id: 2,
        project_id: 1,
        folder: 'Onsite',
        type: 'Default',
        service_name: "Payment tracker",
        folder_type: '',
        feature_key_name: 'payment-tracker'
    },
    {
        folder_id: 2,
        project_id: 1,
        folder: 'Onsite',
        type: 'Default',
        service_name: "Payment certificate",
        folder_type: '',
        feature_key_name: 'payment-certificate'
    },
    {
        folder_id: 2,
        project_id: 1,
        folder: 'Onsite',
        type: 'Default',
        service_name: "Programme",
        folder_type: '',
        feature_key_name: 'programe'
    },
    {
        folder_id: 2,
        project_id: 1,
        folder: 'Onsite',
        type: 'Default',
        service_name: "Completion certificate",
        folder_type: '',
        feature_key_name: 'completion-certificate'
    },
    {
        folder_id: 3,
        project_id: 1,
        folder: 'General',
        type: 'Default',
        service_name: "Refinancing",
        folder_type: '',
        feature_key_name: 'refinancing'
    },
    {
        folder_id: 3,
        project_id: 1,
        folder: 'General',
        type: 'Default',
        service_name: "Cash flow",
        folder_type: '',
        feature_key_name: 'cash-flow'
    },
    {
        folder_id: 3,
        project_id: 1,
        folder: 'General',
        type: 'Default',
        service_name: "Development appraisal",
        folder_type: '',
        feature_key_name: 'development-appraisal'
    }
]

export interface QuickAccessProjects {
    folder_id?: number;
    project_id?: number;
    service_name?: string;
    folder_type?: string;
    address?: string;
    shared_by?: number | null;
}
export interface QuickAccessList {
    display_name?: string;
    projects?: QuickAccessProjects[];
}

export const quickAccessList: QuickAccessList[] = [
    {
        "display_name": "Document",
        "projects": [
            {
                "folder_id": 417,
                "project_id": 164,
                "service_name": "Test Doc",
                "folder_type": "Document",
                "address": "Atchuvely north",
                "shared_by": null
            },
            {
                "folder_id": 475,
                "project_id": 164,
                "service_name": "Document",
                "folder_type": "Document",
                "address": "Atchuvely north",
                "shared_by": null
            },
            {
                "folder_id": 552,
                "project_id": 184,
                "service_name": "Test Document",
                "folder_type": "Document",
                "address": "Atchuvely north",
                "shared_by": null
            }
        ]
    },
    {
        "display_name": "Drawing",
        "projects": [
            {
                "folder_id": 553,
                "project_id": 184,
                "service_name": "Test Drawing",
                "folder_type": "Drawing",
                "address": "Atchuvely north",
                "shared_by": null
            }
        ]
    },
    {
        "display_name": "Test",
        "projects": [
            {
                "folder_id": 393,
                "project_id": 164,
                "service_name": "Test",
                "folder_type": "Doc Drawing",
                "address": "Atchuvely north",
                "shared_by": null
            }
        ]
    },
    {
        "display_name": "Test drawing and document",
        "projects": [
            {
                "folder_id": 551,
                "project_id": 184,
                "service_name": "Planning drawing and documentqwd qwd qwd",
                "folder_type": "Doc Drawing",
                "address": "Atchuvely north",
                "shared_by": null
            }
        ]
    }
]